import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NavigationEnd, Router} from "@angular/router";
import {filter, tap} from "rxjs/operators";
import {Observable} from 'rxjs';
import {ApplicationService} from '../../services/application.service';
import {LoginComponent} from '../login/login.component';

@Component({
    selector: 'app-standby-application',
    templateUrl: './standby-application.component.html',
    styleUrls: ['./standby-application.component.scss'],
    standalone: false
})
export class StandbyApplicationComponent implements OnInit {
  @Input() type: string;
  public old_permit_number: string;
  public application_type: string;

  constructor(private activeModal: NgbActiveModal, private router: Router,
              public applicationService: ApplicationService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      tap(e => this.activeModal.close())
    ).subscribe();
  }

  public close(startInfo) {
    if (startInfo.type === 'renewal') {
      this.activeModal.close();
      const loginComponent = this.modalService.open(LoginComponent);
      loginComponent.componentInstance.type = 'standby';
      loginComponent.componentInstance.idFieldLabel = 'Permit Number';
      // loginComponent.componentInstance.additionalFIelds = ['old_permit_number'];
      loginComponent.componentInstance.resume = false;
      // loginComponent.componentInstance.additionalFieldsMeta = {
      //   old_permit_number: {
      //     label: 'Old Permit Number',
      //     type: 'text',
      //     required: true,
      //     value: this.old_permit_number
      //   }
      // };
      return;
    }
    this.applicationService.loadApplication(this.type, false, startInfo).pipe(
      tap(() => this.activeModal.close())
    ).subscribe();
  }

}
